import { SmileyBlankIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Emoji = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <SmileyBlankIcon {...rest} size={Sizes[size]} color={fill} />;
};

Emoji.displayName = 'Emoji';
